import Tooltip from 'components/Tooltip'

import {
  Container,
  StrengthBarContainer,
  StrengthBarFill,
  StrengthLabel,
  InfoText,
  Row
} from './styles'

function calculateStrength (password) {
  let score = 0

  if (/[0-9]/.test (password)) score++ // Números
  if (/[a-z]/.test (password)) score++ // Letras minúsculas
  if (/[A-Z]/.test (password)) score++ // Letras maiúsculas
  if (/[^A-Za-z0-9]/.test (password)) score++ // Caracteres especiais

  return score
}

const strengthLabels = [
  'Senha fraca',
  'Senha média',
  'Senha forte',
  'Senha muito forte'
]

const strengthColors = ['#FF3939', '#E67E22', '#FFC100', '#44CF6C']

export default function PasswordStrengthBar ({ password }) {
  const score = calculateStrength (password)

  if (password.length === 0) {
    return null
  }

  return (
    <Container>
      <StrengthBarContainer>
        <StrengthBarFill score={score} theme={{ strengthColors }}/>
      </StrengthBarContainer>
      <Row>
        <StrengthLabel score={score} theme={{ strengthColors }}>
          {strengthLabels[score - 1]}
        </StrengthLabel>
        <Tooltip
          place='bottom'
          labelStyle={{ width: 440 }}
          message={
            <InfoText>
              A força da senha é avaliada pelos seguintes critérios:<br/><br/>
              Contém números (0-9)<br/>
              Contém letras minúsculas (a-z)<br/>
              Contém letras maiúsculas (A-Z)<br/>
              Contém caracteres especiais (como !, @, #, $, etc.)<br/><br/>
              Quanto mais critérios sua senha atender, mais forte ela será.
            </InfoText>
          }
        />
      </Row>
    </Container>
  )
}
